import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import ChatInterface from './components/ChatInterface';
import PrivacyDisclaimer from './components/PrivacyDisclaimer';
import useSettings from './hooks/useSettings';
import './App.css';

function App() {
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [showPrivacyDisclaimer, setShowPrivacyDisclaimer] = useState(true);
  const [feedbackUrl, setFeedbackUrl] = useState('');
  
  // Use settings hook to get feedback URL
  const { getSetting, isLoading: settingsLoading, isLoaded } = useSettings();

  // Update feedback URL when settings are loaded
  useEffect(() => {
    if (isLoaded) {
      const url = getSetting('feedback_url', '');
      setFeedbackUrl(url);
    }
  }, [isLoaded, getSetting]);
  
  const handlePrivacyAccept = () => {
    setPrivacyAccepted(true);
    setShowPrivacyDisclaimer(false)
  };

  // Function to toggle privacy disclaimer
  const togglePrivacyDisclaimer = () => {
    setShowPrivacyDisclaimer(!showPrivacyDisclaimer);
  };

  // Show loading indicator while settings are loading
  if (settingsLoading || !isLoaded) {
    return (
      <div className="app-container">
        <main className="app-main">
          <div className="placeholder-content">
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3">Loading application...</p>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="app-container">
      <main className="app-main">
        {privacyAccepted ? (<>
          <ChatInterface />
          <p className="footer-links text-center">
            <a href="#" onClick={(e) => { e.preventDefault(); togglePrivacyDisclaimer(); }}>
              View Privacy Disclaimer
            </a>
            
            {feedbackUrl && (
              <>
              <span className="mx-2">|</span>
              <a href={feedbackUrl} target="_blank" rel="noopener noreferrer">
                Give Feedback
              </a>
              </>
            )}
          </p>
        </>) : (
          <PrivacyDisclaimer onAccept={handlePrivacyAccept} />
        )}
      </main>
      
      <PrivacyDisclaimer 
        onAccept={handlePrivacyAccept}
        show={showPrivacyDisclaimer}
        onClose={togglePrivacyDisclaimer}
       />
    </div>
  );
}

export default App;
